import { render } from "./SobreView.vue?vue&type=template&id=29b2b4e0"
import script from "./SobreView.vue?vue&type=script&lang=js"
export * from "./SobreView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__